/** True when a quote patch would change any field already stored for that symbol. */
export function quotePatchChanges(prevQuote, patch) {
  if (!patch || typeof patch !== 'object') return false;
  if (!prevQuote) return true;
  for (const key of Object.keys(patch)) {
    if (patch[key] !== prevQuote[key]) return true;
  }
  return false;
}

/**
 * Merge queued per-symbol patches into the quote map.
 * Returns the previous map when nothing visible changed, so React can skip the update.
 */
export function mergeQuotePatches(prev, patchesBySymbol) {
  const current = prev && typeof prev === 'object' ? prev : {};
  const patches = patchesBySymbol && typeof patchesBySymbol === 'object' ? patchesBySymbol : {};
  let changed = false;
  const next = { ...current };
  for (const symbol of Object.keys(patches)) {
    const patch = patches[symbol];
    if (!symbol || !patch) continue;
    const prevQuote = current[symbol];
    if (!quotePatchChanges(prevQuote, patch)) continue;
    next[symbol] = { ...(prevQuote || {}), ...patch };
    changed = true;
  }
  return changed ? next : current;
}
